import { render, staticRenderFns } from "./chatRecord.vue?vue&type=template&id=98806d0c"
import script from "./chatRecord.vue?vue&type=script&lang=js"
export * from "./chatRecord.vue?vue&type=script&lang=js"
import style0 from "./chatRecord.vue?vue&type=style&index=0&id=98806d0c&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports